/* eslint-disable @angular-eslint/no-output-rename */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FinancialPlanningService, FPGroupRow, GroupKey, WorkingGroupKeyMember } from './services/financial-planning.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MaintenanceService } from './services/maintenance.service';
import { CloneReportingGroupKeyResource, GLReportingGroup, GLReportingGroupMember, GroupKeyMemberResourceWithOriginals, UserStateInfo } from 'src/app/client-api.service';
import { UserService } from 'src/app/core-services/user.service';
import { filter, tap } from 'rxjs/operators';
import { PanelSize } from 'src/app/shared/tcc-ui/simple-panel/models';

@Component({
  selector: 'app-financial-planning-maintenance-menu',
  templateUrl: './financial-planning-maintenance-menu.component.html',
  styleUrls: ['./financial-planning-maintenance-menu.component.scss']
})
export class FinancialPlanningMaintenanceMenuComponent implements OnInit {

  @Input() groupToClone: GroupKey | undefined;

  @ViewChild('newGroupKey') newGroupKey: ElementRef<HTMLInputElement> | undefined;
  @ViewChild('newGroupName') newGroupName: ElementRef<HTMLInputElement> | undefined;

  @Output('clone') clone: EventEmitter<any> = new EventEmitter<GroupKey>();

  activeTab = 0;
  currentGroupKeySelected: any;
  currentGroupKeySelectedSub: Subscription | undefined;
  currentGroupKeyToClone: GroupKey | undefined;

  currentGLReportingGroup: GLReportingGroup | undefined;
  dataSetUpdateCounts = 0;

  fpGroupRows: FPGroupRow[] | undefined;
  groupKeyMemberDuplicateCounts = 0;
  groupKeysWithMembers: GLReportingGroup[] | undefined;

  state: 'initializing' | 'loading' | 'ready' | 'saving';
  tabs: string[] = [];
  panalSize: PanelSize = 'large';    
  panalSizeSubscription: Subscription | undefined;
  
  showAddGroupKeyMembersTable = false;
  showCloneGroupKey = false;
  showMembersPanal = false;

  userChangeSubject = new BehaviorSubject<UserStateInfo | undefined>(undefined);
  userSub: Subscription | undefined;
  workingGroupKeyMemberList: WorkingGroupKeyMember[] | undefined;


  hasNoChildBladesOpen = false;

  constructor(private fpService: FinancialPlanningService,
              private maintenanceService: MaintenanceService,
              private userSvc: UserService
              ) {
    this.state = 'initializing';
    this.panalSizeSubscription = this.maintenanceService.getMaintenanceComponenetPanelSize().subscribe(
      res => {
        this.panalSize = res;
    });
  }

  ngOnInit(): void {
    this.state = 'ready';
    this.showMembersPanal = false;

    this.userSub = this.userSvc.currentUser$.pipe(
      filter((u): u is Required<UserStateInfo> => !!u?.email)      
    ).subscribe((u) => {        
        if(u.features.includes('Revenue')) {
          this.tabs = ['Installer' 
                       , 'Installer Tracking'];  
        } if(u.features.includes('Admin')) {
          this.tabs = ['Account Split Definitions'
                       , 'Application Views'
                       , 'FP Lists'
                       , 'Installer'
                       , 'Installer Tracking'             
                       /*, 'Ledger View Info', */
                       , 'Management Fee Account Splits'
                       , 'Organizations'
                       , 'Org Mapping Lookup'                        
                       , 'Position Types'
                       , 'System Config' ];
        }
        this.state = 'ready';
        this.userChangeSubject.next(u);
      },
      err => {
        alert('Error Authenticating');
      });
      this.getReportingGroupsSub();
      this.fpService.refreshInstallerTrackingObservable();
  }

  add() {
    this.showAddGroupKeyMembersTable = true;
  }


  checkForGroupKeyMemberDupesInWorkingDataSet() {
    this.groupKeyMemberDuplicateCounts = 0;
    const tempList = this.workingGroupKeyMemberList;

    for(let i = 0; i < this.workingGroupKeyMemberList?.length!; i++) {
      const rows = tempList?.filter((g) => g.groupKey === this.workingGroupKeyMemberList![i].groupKey &&
                                           g.orgCode === this.workingGroupKeyMemberList![i].orgCode! &&
                                           g.propertyCode === this.workingGroupKeyMemberList![i].propertyCode!);

    if(rows?.length! > 1){
        this.groupKeyMemberDuplicateCounts++;
      }
    }
  }

  cloneGroupKey(cloneGroupKeyResource: CloneReportingGroupKeyResource) {
    this.fpService.cloneGLReportingGroup(cloneGroupKeyResource)
                                 .subscribe(res => {
                                    this.getReportingGroupsSub();
                                    this.closeCloneGroupKey();
                                    alert('cloned');
                                 },
                                  err => {
                                    alert('Error cloning ReportGroup!');
                                  }
                                 );
  }

  close() {
    this.showMembersPanal = false;
    this.fpService.clearCurrentGroupKeySubscriptionValue();
  }

  closeCloneGroupKey() {
    this.showCloneGroupKey = false;
  }

  deleteGroupKey(event: any) {

    const groupKey = this.groupKeysWithMembers?.find(gk => gk.groupKey === event.row.groupKey);
    if(groupKey && groupKey.glReportingGroupMember?.length! > 0) {
      alert('The Reporting Group cannot be deleted while it contains members, please delete' +
            ' the group members prior to deleting the Reporting Group.');
      return;
    }


    if(confirm('Are you sure you want to delete this Reporting Group "' + event.row.groupKey + '" and all its Members?')) {
      this.fpService.deleteGLReportingGroup(event.row.groupKey)
                                   .subscribe(
                                    res => {
                                      // alert('deleted');
                                      this.getReportingGroupsSub();
                                      this.showMembersPanal = false;
                                    },
                                    err => {
                                      alert('Error deleting Reporting Group');
                                    });
    }
  }

  deleteGLReportingGroupMember(groupKey: string, orgCode: string, propertyCode: string) {
    if(confirm('Are you sure you want to delete this Group Key Member?')){
    this.fpService.deleteGLReportingGroupMember(groupKey, orgCode, propertyCode)
                                 .subscribe(
                                  res => {
                                    this.getReportingGroupsSub();
                                  },
                                  err => {
                                    alert('An error occured delete this GroupKey Member');
                                    this.getReportingGroupsSub();
                                  });
    }
  }


  displayGroupKeyEditPanal() {
    return this.showMembersPanal;
  }

    fieldChanged(elem: HTMLInputElement) {

    const parsedInputElementId = this.parseInputElementId(elem.id);

    if (parsedInputElementId.fieldName === 'orgCode') {
      if (elem.value === parsedInputElementId.orgCode) {
        elem.style.color = 'black';
      }
      else {
        elem.style.color = 'red';
      }
      this.workingGroupKeyMemberList![parsedInputElementId.rowIndex!].orgCode = elem.value;
    }
    else if (parsedInputElementId.fieldName === 'propertyCode') {
      if (elem.value === parsedInputElementId.propertyCode) {
        elem.style.color = 'black';
      }
      else {
        elem.style.color = 'red';
      }
      this.workingGroupKeyMemberList![parsedInputElementId.rowIndex!].propertyCode = elem.value;
    }

    this.workingGroupKeyMemberList![parsedInputElementId.rowIndex!].isDIrty =
                                                    ((this.workingGroupKeyMemberList![parsedInputElementId.rowIndex!].orgCode !==
                                                    this.workingGroupKeyMemberList![parsedInputElementId.rowIndex!].originalOrgCode) ||
                                                    (this.workingGroupKeyMemberList![parsedInputElementId.rowIndex!].propertyCode !==
                                                    this.workingGroupKeyMemberList![parsedInputElementId.rowIndex!].originalPropertyCode));
    this.updateDataSetUpdateCounts();
    this.checkForGroupKeyMemberDupesInWorkingDataSet();
  }

  getReportingGroupsSub() {
    this.state = 'loading';
    this.fpService.getReportingGroups()
      .pipe(
        tap((result) => {
          this.fpGroupRows = result.map(r => {
            const row: FPGroupRow = {
              groupKey: r.groupKey!,
              name: r.name!
            };
            return row;
          });
        }),
        tap((gk) => {
          this.groupKeysWithMembers = gk;
          this.onGroupKeyChange();
          this.state = 'ready';
        }))
      .subscribe();
  }

  hideAddNewGroupKeyMember() {
    this.showAddGroupKeyMembersTable = false;
  }
  
  
  openCloneGroupKey(event: any) {
    this.currentGroupKeyToClone = event.row;
    this.showCloneGroupKey = true;
  }

  onGroupKeyChange = () => {
    // eslint-disable-next-line max-len
    this.currentGroupKeySelectedSub = this.fpService.getCurrentGroupKeySubscriptionValue().subscribe(g => {
      this.currentGroupKeySelected = g;
      if (g !== '') {
        this.currentGLReportingGroup = this.groupKeysWithMembers?.find(gk => gk.groupKey === g);
        this.workingGroupKeyMemberList = [];
        if (this.currentGLReportingGroup && this.currentGLReportingGroup.glReportingGroupMember) {

          for (let i = 0; i < this.currentGLReportingGroup?.glReportingGroupMember?.length; i++) {

            // eslint-disable-next-line prefer-const
            let workingGroupKeyMember: WorkingGroupKeyMember = {
              groupKey: this.currentGLReportingGroup?.glReportingGroupMember[i].groupKey,
              orgCode: this.currentGLReportingGroup?.glReportingGroupMember[i].orgCode,
              originalOrgCode: this.currentGLReportingGroup?.glReportingGroupMember[i].orgCode,
              propertyCode: this.currentGLReportingGroup?.glReportingGroupMember[i].propertyCode,
              originalPropertyCode: this.currentGLReportingGroup?.glReportingGroupMember[i].propertyCode,
              // using ^ as its not likely to be in the data - use split('^') to seperate them
              // to be used later to determned values that have changed
              orgCodeInputElementId: 'orgCode^' +
                this.currentGLReportingGroup?.glReportingGroupMember[i].groupKey + '^' +
                this.currentGLReportingGroup?.glReportingGroupMember[i].orgCode + '^' +
                this.currentGLReportingGroup?.glReportingGroupMember[i].propertyCode + '^' + i,

              propertyCodeInputElementId: 'propertyCode^' +
                this.currentGLReportingGroup?.glReportingGroupMember[i].groupKey + '^' +
                this.currentGLReportingGroup?.glReportingGroupMember[i].orgCode + '^' +
                this.currentGLReportingGroup?.glReportingGroupMember[i].propertyCode + '^' + i,
              isDIrty: false
            };

            this.workingGroupKeyMemberList.push(workingGroupKeyMember);
          }
          this.updateDataSetUpdateCounts();
          this.checkForGroupKeyMemberDupesInWorkingDataSet();
          this.showMembersPanal = true;
          this.state = 'ready';
        }
      }
    });
  };

  parseInputElementId(elementId: string | undefined): CurrentInputElement {
    const splitElement = elementId?.split('^');
    const currentInputElement: CurrentInputElement = {
      fieldName: splitElement![0],
      groupKey: splitElement![1],
      orgCode: splitElement![2],
      propertyCode: splitElement![3],
      rowIndex: parseInt(splitElement![4], 10)
    };

    return currentInputElement;
  }

  refresh() {
    this.getReportingGroupsSub();
  }

  saveAddNewGroupKeyMember(newGroupKeyMember: GLReportingGroupMember) {

    const existingGroupKeyMember = this.workingGroupKeyMemberList?.filter(g => (g.groupKey === newGroupKeyMember.groupKey &&
                                                                          g.orgCode === newGroupKeyMember.orgCode &&
                                                                          g.propertyCode === newGroupKeyMember.propertyCode));

    if(existingGroupKeyMember?.length !== 0) {
      alert('This Groupkey, OrgCode and PropertyCode combination already exists!');
      return;
    }

    this.fpService.insertGLReportingGroupMember(newGroupKeyMember).subscribe(r => {
      this.showAddGroupKeyMembersTable = false;
      this.getReportingGroupsSub();
    }, e => {
      alert('Error saving new group key member');
    });
  }

  saveAllDirtyGroupMembers() {
      this.state = 'saving';
      const groupKeyMemberChanges = this.workingGroupKeyMemberList?.filter(g => g.isDIrty);

      const memberUpdates: GroupKeyMemberResourceWithOriginals[] = [];

      for(let i = 0; i < groupKeyMemberChanges?.length!; i++){
        const memberUpdate: GroupKeyMemberResourceWithOriginals = {
          groupKey: groupKeyMemberChanges![i].groupKey!,
          orgCode: groupKeyMemberChanges![i].orgCode!,
          propertyCode: groupKeyMemberChanges![i].propertyCode!,
          originalOrgCode: groupKeyMemberChanges![i].originalOrgCode!,
          originalPropertyCode: groupKeyMemberChanges![i].originalPropertyCode!
        };

        memberUpdates.push(memberUpdate);
      }

      this.fpService.patchReportingGroupMembers(memberUpdates)
                    .subscribe(r => {
                    this.getReportingGroupsSub();
                    }, e => {
                    alert('Error Saving member updates!');
                    this.getReportingGroupsSub();
                    });
}

  // menu selector
  setActiveTab(index: number): void {    
    this.activeTab = index;
  }

  updateDataSetUpdateCounts() {
    this.dataSetUpdateCounts = (this.workingGroupKeyMemberList?.filter((obj) => obj.isDIrty === true).length) ?
                               (this.workingGroupKeyMemberList?.filter((obj) => obj.isDIrty === true).length) :
                               0;
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////// arrow key logic
/////////////////////////////////////////////////////////////////////////////////////////////////////// arrow key logic
/////////////////////////////////////////////////////////////////////////////////////////////////////// arrow key logic
onDirectionEvent(elem: HTMLInputElement, evt: KeyboardEvent) {
    // for ArrowLeft and Right, treat shift as resizing of selection area.

    const parsedInputElementId = this.parseInputElementId(elem.id);
    let moveFocus = true;
    let nextElemId = '';

    switch (evt.key) {
      case 'Tab':
        if (parsedInputElementId.rowIndex === 0) { // top row
          if (parsedInputElementId.fieldName === 'orgCode') {
            if(evt.shiftKey){
              // do nothing
              moveFocus = false;
            }
            else { // w/o shift key - move to the next field same row
              nextElemId = 'propertyCode^' + parsedInputElementId.groupKey + '^' +
                                                    parsedInputElementId.orgCode + '^' +
                                                    parsedInputElementId.propertyCode + '^' +
                                                    parsedInputElementId.rowIndex.toString();
            }
          }
          else if (parsedInputElementId.fieldName === 'propertyCode') {
            if (evt.shiftKey) { // shift key -- move back one on same row
              nextElemId = 'orgCode^' + parsedInputElementId.groupKey + '^' +
                                              parsedInputElementId.orgCode + '^' +
                                              parsedInputElementId.propertyCode + '^' +
                                              parsedInputElementId.rowIndex.toString();
            }
            else { // no shift key - move to first field in next row
              const nextRow = this.workingGroupKeyMemberList![parsedInputElementId.rowIndex + 1];
              nextElemId = 'orgCode^' + nextRow.groupKey + '^' +
                                              nextRow.originalOrgCode + '^' +
                                              nextRow.originalPropertyCode + '^' +
                                              (parsedInputElementId.rowIndex + 1).toString();
            }
          }
        }
        else if(parsedInputElementId.rowIndex === (this.workingGroupKeyMemberList!.length - 1)) { // last row
          if (parsedInputElementId.fieldName === 'orgCode') {
            if (evt.shiftKey) {
              const nextRow = this.workingGroupKeyMemberList![parsedInputElementId.rowIndex! - 1];
              nextElemId = 'propertyCode^' + nextRow.groupKey + '^' +
                                                    nextRow.originalOrgCode + '^' +
                                                    nextRow.originalPropertyCode + '^' +
                                                    (parsedInputElementId.rowIndex! - 1).toString();
            }
            else { // no shift key
              nextElemId = 'propertyCode^' + parsedInputElementId.groupKey + '^' +
                                                  parsedInputElementId.orgCode + '^' +
                                                  parsedInputElementId.propertyCode + '^' +
                                                  parsedInputElementId.rowIndex!.toString();
            }
          }
          else if (parsedInputElementId.fieldName === 'propertyCode') {
            if (evt.shiftKey) {
               nextElemId = 'orgCode^' + parsedInputElementId.groupKey + '^' +
                                              parsedInputElementId.orgCode + '^' +
                                              parsedInputElementId.propertyCode + '^' +
                                              parsedInputElementId.rowIndex!.toString();
            }
            else { // no shift key
              moveFocus = false;
            }
          }
        }
        else { // not the top row
          if (parsedInputElementId.fieldName === 'orgCode') {
            if (evt.shiftKey) { // w shift key move to the property code of the previous row
              const nextRow = this.workingGroupKeyMemberList![parsedInputElementId.rowIndex! - 1];
              nextElemId = 'propertyCode^' + nextRow.groupKey + '^' +
                                                    nextRow.originalOrgCode + '^' +
                                                    nextRow.originalPropertyCode + '^' +
                                                    (parsedInputElementId.rowIndex! - 1).toString();
            }
            else { // no shift key - move to first field in next row
              nextElemId = 'propertyCode^' + parsedInputElementId.groupKey + '^' +
                                                    parsedInputElementId.orgCode + '^' +
                                                    parsedInputElementId.propertyCode + '^' +
                                                    parsedInputElementId.rowIndex!.toString();
            }
          }
          else if (parsedInputElementId.fieldName === 'propertyCode') {
            if (evt.shiftKey) { // w shift key
              nextElemId = 'orgCode^' + parsedInputElementId.groupKey + '^' +
                                              parsedInputElementId.orgCode + '^' +
                                              parsedInputElementId.propertyCode + '^' +
                                              parsedInputElementId.rowIndex!.toString();
            }
            else {
              const nextRow = this.workingGroupKeyMemberList![parsedInputElementId.rowIndex! + 1];
              nextElemId = 'orgCode^' + nextRow.groupKey + '^' +
                                              nextRow.originalOrgCode + '^' +
                                              nextRow.originalPropertyCode + '^' +
                                              (parsedInputElementId.rowIndex! + 1).toString();
            }
          }
        }

        break;
      case 'ArrowLeft':
        if (parsedInputElementId.rowIndex === 0) { // top row
          if (parsedInputElementId.fieldName === 'orgCode') {
            moveFocus = false;
          }
          else if (parsedInputElementId.fieldName === 'propertyCode') {
            nextElemId = 'orgCode^' + parsedInputElementId.groupKey + '^' +
                                              parsedInputElementId.orgCode + '^' +
                                              parsedInputElementId.propertyCode + '^' +
                                              parsedInputElementId.rowIndex!.toString();
          }
        }
        else { // all middle rows
          if (parsedInputElementId.fieldName === 'orgCode') {
            const nextRow = this.workingGroupKeyMemberList![parsedInputElementId.rowIndex! - 1];
            nextElemId = 'propertyCode^' + nextRow.groupKey + '^' +
                                                  nextRow.originalOrgCode + '^' +
                                                  nextRow.originalPropertyCode + '^' +
                                                  (parsedInputElementId.rowIndex! - 1).toString();
          }
          else if (parsedInputElementId.fieldName === 'propertyCode') {
            nextElemId = 'orgCode^' + parsedInputElementId.groupKey + '^' +
                                              parsedInputElementId.orgCode + '^' +
                                              parsedInputElementId.propertyCode + '^' +
                                              parsedInputElementId.rowIndex!.toString();
          }
        }
        break;
      case 'ArrowUp':
        if (parsedInputElementId.rowIndex === 0) { // top row
          moveFocus = false;
        }
        else {
          if (parsedInputElementId.fieldName === 'orgCode') {
            const nextRow = this.workingGroupKeyMemberList![parsedInputElementId.rowIndex! - 1];
                      nextElemId = 'orgCode^' + nextRow.groupKey + '^' +
                                                nextRow.originalOrgCode + '^' +
                                                nextRow.originalPropertyCode + '^' +
                                                (parsedInputElementId.rowIndex! - 1).toString();
            }
            else if (parsedInputElementId.fieldName === 'propertyCode') {
              const nextRow = this.workingGroupKeyMemberList![parsedInputElementId.rowIndex! - 1];
                      nextElemId = 'propertyCode^' + nextRow.groupKey + '^' +
                                                nextRow.originalOrgCode + '^' +
                                                nextRow.originalPropertyCode + '^' +
                                                (parsedInputElementId.rowIndex! - 1).toString();
            }
        }

        break;
      case 'ArrowRight':
       if(parsedInputElementId.rowIndex === (this.workingGroupKeyMemberList!.length - 1)) { // last row
          if (parsedInputElementId.fieldName === 'orgCode') {
            nextElemId = 'propertyCode^' + parsedInputElementId.groupKey + '^' +
                                            parsedInputElementId.orgCode + '^' +
                                            parsedInputElementId.propertyCode + '^' +
                                            parsedInputElementId.rowIndex!.toString();
          }
          else if (parsedInputElementId.fieldName === 'propertyCode') {
            moveFocus = false;
          }
        }
        else { // middle and top rows
          if (parsedInputElementId.fieldName === 'orgCode') {
            nextElemId = 'propertyCode^' + parsedInputElementId.groupKey + '^' +
                                            parsedInputElementId.orgCode + '^' +
                                            parsedInputElementId.propertyCode + '^' +
                                            parsedInputElementId.rowIndex!.toString();
          }
          else if (parsedInputElementId.fieldName === 'propertyCode') {
            const nextRow = this.workingGroupKeyMemberList![parsedInputElementId.rowIndex! + 1];
            nextElemId = 'orgCode^' + nextRow.groupKey + '^' +
                                                  nextRow.originalOrgCode + '^' +
                                                  nextRow.originalPropertyCode + '^' +
                                                  (parsedInputElementId.rowIndex! + 1).toString();
          }
      }

        break;
      case 'ArrowDown':
        if(parsedInputElementId.rowIndex === (this.workingGroupKeyMemberList!.length - 1)) { // last row
          moveFocus = false;
        }
        else {
          if (parsedInputElementId.fieldName === 'orgCode') {
            const nextRow = this.workingGroupKeyMemberList![parsedInputElementId.rowIndex! + 1];
                      nextElemId = 'orgCode^' + nextRow.groupKey + '^' +
                                                nextRow.originalOrgCode + '^' +
                                                nextRow.originalPropertyCode + '^' +
                                                (parsedInputElementId.rowIndex! + 1).toString();
            }
            else if (parsedInputElementId.fieldName === 'propertyCode') {
              const nextRow = this.workingGroupKeyMemberList![parsedInputElementId.rowIndex! + 1];
                      nextElemId = 'propertyCode^' + nextRow.groupKey + '^' +
                                                nextRow.originalOrgCode + '^' +
                                                nextRow.originalPropertyCode + '^' +
                                                (parsedInputElementId.rowIndex! + 1).toString();
            }
        }
        break;
      case 'Enter':

        break;
      case 'End':

        break;
      case 'Home':

        break;
      case 'PageUp':

        break;
      case 'PageDown':

        break;
    }


    if (moveFocus === true) {
      document.getElementById(nextElemId)?.focus();
    }
  }
}

interface CurrentInputElement {
  fieldName?: string | undefined;
  groupKey?: string | undefined;
  orgCode?: string | undefined;
  propertyCode?: string | undefined;
  rowIndex?: number | undefined;
}